interface Rect {
	left: number;
	right: number;
	top: number;
	bottom: number;
}

export default function domRectContains(rect: Rect, x: number, y: number): boolean {
	return rect.left <= x && x <= rect.right && rect.top <= y && y <= rect.bottom;
}
